import { useEffect } from 'react';

import { createSafeContext } from '@/package';
import { useLabelingBoxStore, usePcdRenderingStore } from '@/store';
import type { BoxWithLabel } from '@/type';

import { useLabelingBoxPool } from './hook/useLabelingBoxPool';
import type { LabelingBoxContextValue } from './type';

export const LabelingBoxContext = createSafeContext<LabelingBoxContextValue>(
  {} as LabelingBoxContextValue,
  'LabelingBoxContext',
);

export const LabelingBoxContextProvider = ({
  children,
}: React.PropsWithChildren) => {
  const labelingStore = useLabelingBoxStore();
  const pcdIndex = usePcdRenderingStore(state => state.pcdIndex);
  const { labelingBoxList, selectedLabelingBoxList } = useLabelingBoxPool();
  const historyState = useLabelingBoxStore.temporal.getState();

  const removeBox = (id: BoxWithLabel['id']) => {
    removeBoxList([id]);
  };

  const removeBoxList = (idList: BoxWithLabel['id'][]) => {
    labelingStore.removeBoxList(idList);
  };

  useEffect(() => {
    historyState.clear();
  }, [pcdIndex]);

  useEffect(() => {
    return () => {
      historyState.clear();
    };
  }, []);

  return (
    <LabelingBoxContext.Provider
      value={{
        ...labelingStore,
        labelingBoxList,
        selectedLabelingBoxList,
        history: useLabelingBoxStore.temporal,
        removeBox,
      }}
    >
      {children}
    </LabelingBoxContext.Provider>
  );
};
